import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import http from '@lib/http-client'
import { NotesStore } from './types'

export const useNotesStore = create<NotesStore>()(
  devtools(set => ({
    getUserNotes: async (userId: number) => {
      try {
        const endpoint = `/user/${userId}/notes`
        const response = await http.get(endpoint)

        for (const note of response) {
          note._created = new Date(note._created)
        }

        return response
      } catch (error) {
        console.error('Error fetching user notes:', error)
        return []
      }
    },
    postUserNote: async (userId: number, text: string) => {
      try {
        const endpoint = `/user/${userId}/notes`
        const response = await http.post(endpoint, { text })

        if (!!response?.note?._created) {
          response.note._created = new Date(response.note._created)
        }

        return response
      } catch (error) {
        console.error('Error posting user note:', error)
        return { success: false }
      }
    },
    deleteUserNote: async (userId: number, noteId: number) => {
      try {
        const endpoint = `/user/${userId}/notes/${noteId}`
        const response = await http.delete(endpoint)

        return !!response?.success
      } catch (error) {
        console.error('Error deleting user note:', error)
        return null
      }
    }
  }))
)
